import React from "react";
import {Col, Row} from "react-bootstrap";
import styled from "styled-components";
import {COLORS} from './theme';
import {useTranslation} from "react-i18next";
import Badge from "./Badge";

const Label = styled(Col)`
  ${props => !props.$secondary && `
    font-weight: 600;
  `}
`

const Value = styled(Col)`
`

const StyledRow = styled(Row)`
  ${props => !props.$hasChildren && !props.$secondary && `
    padding: 10px 0;
    min-height: 50px;
  `}
  ${props => props.$hasChildren && `
    padding-top: 10px;
    padding-bottom: 2px;
  `}
  ${props => !props.$secondary && `
    &:not(:first-child) {
      border-top: 1px solid ${COLORS.lightGrey};
    }
  `}
  ${props => props.$secondary && `
    color: ${COLORS.midGrey};
  `}
  ${props => props.$secondary && props.$lastChild && `
    padding-bottom: 10px;
  `}
  margin: 0;
`

const nullOrEmpty = (v) => v == null || v.length == 0

function ShowItem(props) {
  const { t } = useTranslation();

  const isShowItem = (elt) => elt.type == ShowItem
  const childrenValues = React.Children.toArray(props.children).filter(elt => !isShowItem(elt))
  const childrenShowItems = React.Children.toArray(props.children).filter(isShowItem)

  const labelSize = {
    sm: props.sm || 6,
    md: props.md || 5,
    lg: props.lg || 4,
    xl: props.xl || 3,
  }

  const value = () => {
    const valueOrPlaceholder = !nullOrEmpty(props.value) ? props.value : props.placeholder

    if (valueOrPlaceholder != null) {
      if (props.bool) {
        return t(`${valueOrPlaceholder}`)
      } else if (props.array) {
        return valueOrPlaceholder.map((val) => (<Badge key={val} color={COLORS.lightGrey} style={{marginBottom: "3px"}}>{val}</Badge>))
      } else {
        return valueOrPlaceholder
      }
    } else if (childrenValues) {
      return childrenValues
    } else {
      return '-'
    }
  }

  return (
    <>
      <StyledRow className={`align-items-${props.align}`} $secondary={props.secondary} $hasChildren={childrenShowItems.length > 0} $lastChild={props.lastChild}>
        {props.label && <Label {...labelSize} style={props.labelStyle} $secondary={props.secondary}>
          {props.label}
        </Label>}
        <Value style={props.valueStyle} $secondary={props.secondary}>
          {value()}
        </Value>
      </StyledRow>
      {childrenShowItems.map((child, i) => {
        return React.cloneElement(child, {secondary: true, lastChild: i == childrenShowItems.length - 1})
      })}
    </>
  )
}

export default ShowItem

ShowItem.defaultProps = {
  align: 'center'
}
